export default {
  items: [
    {
      name: 'Menu Principal',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Validar Usuários',
          url: '/validar-usuarios-tutor',
          icon: 'fa fa-users'
        },
        {
          name: 'Locais',
          url: '/locais',
          icon: 'fa fa-users'
        },
        {
          name: 'Municípios',
          url: '/municipios-tutor',
          icon: 'fa fa-bank'
        },
        {
          name: 'Programas do Município',
          url: '/programas-municipios',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Relatórios de Encontros',
          url: '/relatorio-encontros',
          icon: 'fa fa-book'
        },
        {
          name: 'Avaliações das Beneficiárias',
          url: '/avaliar-voluntarias',
          icon: 'fa fa-star'
        },
        {
          name: 'Feedbacks',
          url: '/feedbacks',
          icon: 'fa fa-comments-o'
        },
        {
          name: 'Relatórios Mensais',
          url: '/relatorio-mensal',
          icon: 'fa fa-tasks'
        },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navTutor.js